import React from 'react';
import PropTypes from 'prop-types';

import * as S from '../styles';

export function HappyFace({ inactive, disabled }) {
    return (
        <S.SVGContainer $disabled={disabled} viewBox="0 0 128 121">
            <S.Background $active={!inactive} fill="#75CD7D" d="M69.5 119C37.2 119 11 92.8 11 60.5S37.2 2 69.5 2 128 28.2 128 60.5 101.8 119 69.5 119z" />
            <S.Shape styleName="face-shape" fill="#353535" d="M84 73.2c.3.7.2 1.5-.3 2.1-5.1 7.7-13.8 12.8-23.6 12.8S41.6 83 36.4 75.2c-.5-.6-.6-1.4-.3-2.1.3-.7 1-1.1 1.7-1.2.8 0 1.5.4 1.8 1C44.1 79.6 51.5 84 59.9 84s15.8-4.4 20.3-11.1c.4-.7 1.1-1.1 1.8-1 1 .1 1.7.6 2 1.3zm36.5-12.7c0 33.1-26.9 60-60 60s-60-26.9-60-60 26.9-60 60-60 60 26.9 60 60zm-3 0c0-31.4-25.6-57-57-57s-57 25.6-57 57 25.6 57 57 57 57-25.6 57-57z" />
        </S.SVGContainer>
    );
}

HappyFace.propTypes = {
    inactive: PropTypes.bool,
    disabled: PropTypes.bool,
};

HappyFace.defaultProps = {
    inactive: false,
    disabled: false,
};

export default HappyFace;
